import Icon from "../controls/Icon";

const ActionButton = ({
    actionType,
    fieldType,
    _id,
    groupingId,
    parentValue,
    setterFunc,
    handleResetValue,
    deleteItem,
    valueToCopy
}) => {
    switch (actionType) {
        case "reset": {
            return <Icon icon="SettingsBackupRestore"
                onClick={() => {
                    setterFunc(parentValue);
                    handleResetValue({ _id, settingsGroupIdentifier: groupingId });
                }}
                className="clickable d-block" />
        }
        case "delete": {
            return <Icon icon="DeleteOutlined"
                onClick={() => deleteItem({ fieldType, _id, groupingId })}
                className="clickable d-block" />
        }
        case "copy": {
            return <Icon icon="FileCopy"
                onClick={() => {
                    navigator.clipboard.writeText(valueToCopy);
                }}
                className="clickable d-block" />
        }

        default: <></>
    }
};

export default ActionButton;